import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

// Services
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  /**
   * Constructor
   */

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) { }

  /**
   * Methods
   */

  setup(): void {
    this.registerMaterialIcons();
  }

  registerMaterialIcons(): void {
    // Icons
    const baseHref = '';
    const iconsPath = `..${baseHref}/assets/icons`;
    this.matIconRegistry.addSvgIcon('arrow-left', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/arrow-left.svg`));
    this.matIconRegistry.addSvgIcon('close', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/close.svg`));
    this.matIconRegistry.addSvgIcon('copy', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/copy.svg`));
    this.matIconRegistry.addSvgIcon('copy-link', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/copy-link.svg`));
    this.matIconRegistry.addSvgIcon('chart-graph', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/chart-graph.svg`));
    this.matIconRegistry.addSvgIcon('dots', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/dots.svg`));
    this.matIconRegistry.addSvgIcon('eye', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/eye.svg`));
    this.matIconRegistry.addSvgIcon('hbo-logo-small', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/hbo-logo-small.svg`));
    this.matIconRegistry.addSvgIcon('hbo-logo', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/hbo-logo.svg`));
    this.matIconRegistry.addSvgIcon('link', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/link.svg`));
    this.matIconRegistry.addSvgIcon('max-logo', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/max-logo.svg`));
    this.matIconRegistry.addSvgIcon('plus', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/plus.svg`));
    this.matIconRegistry.addSvgIcon('refresh', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/refresh.svg`));
    this.matIconRegistry.addSvgIcon('settings', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/settings.svg`));
    this.matIconRegistry.addSvgIcon('slack', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/slack.svg`));
    this.matIconRegistry.addSvgIcon('trash', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/trash.svg`));
    this.matIconRegistry.addSvgIcon('volume-mute', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/volume-mute.svg`));
    this.matIconRegistry.addSvgIcon('volume', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/volume.svg`));
    // Playback actions
    this.matIconRegistry.addSvgIcon('forward-end', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/forward-end.svg`));
    this.matIconRegistry.addSvgIcon('forward-next', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/forward-next.svg`));
    this.matIconRegistry.addSvgIcon('forward-out-point', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/forward-out-point.svg`));
    this.matIconRegistry.addSvgIcon('forward', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/forward.svg`));
    this.matIconRegistry.addSvgIcon('loop', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/loop.svg`));
    this.matIconRegistry.addSvgIcon('out-point', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/out-point.svg`));
    this.matIconRegistry.addSvgIcon('pause', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/pause.svg`));
    this.matIconRegistry.addSvgIcon('play', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/play.svg`));
    this.matIconRegistry.addSvgIcon('stop', this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconsPath}/stop.svg`));
  }
}
